import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import { ReactComponent as CheckIcon } from 'icons/components/check.svg';

import './index.less';
import './themes/default.less';

export default class CheckBox extends MainComponent {

    static propTypes = {
        title: PropTypes.string,
        titleStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        checked: PropTypes.bool,
        onClick: PropTypes.func
    };
    static defaultProps = {
        title: "",
        titleStyle: null,
        checked: false,
        onClick: null
    };

    set value(value) {
        if (value)
            this._helper.dom.addClass(this.checkBox, "activeCheck");
        else
            this._helper.dom.removeClass(this.checkBox, "activeCheck");
    }

    get value() {
        return this._helper.dom.hasClass(this.checkBox, "activeCheck");
    }

    render() {
        const { checked, onClick, title, titleStyle } = this.props;

        const cl = checked ? "activeCheck" : "";
        const titleCl = titleStyle || "";

        return (
            <div ref={el => this.checkBox = el} className={`checkboxCont flex centerV ${title ? "gap8" : ""} hand ${cl}`} onClick={onClick}>
                <div className="checkbox flex centerAll">
                    <CheckIcon />
                </div>
                {title && <div className={`checkboxTitle text p1 ${titleCl}`}>
                    {this.tr(title)}
                </div>}

            </div>
        );

    }
}
